export class AppDirectoryApiError extends Error implements IErrorAppDirectoryApi {
  constructor(public statusCode: number, public message: string, public detail?: { msg: string }) {
    super()
    this.statusCode = statusCode
    this.message = message
    this.detail = detail
  }
}
